import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import ReactSelect from '../ReactSelect';

interface ReactSelectUserListsProps {
  placeholder: string;
  [s: string]: any; // ReactSelectProps
}

const ReactSelectUserLists = ({
  placeholder,
  ...props
}: ReactSelectUserListsProps) => {
  const { currentNetwork } = useDefaultAppContexts();

  const { isLoading, data } = useQueryOnce(
    'backoffice_network_user_lists_path',
    () =>
      axios
        .get(
          Routes.backoffice_network_user_lists_path(currentNetwork.id, {
            per_page: 9999,
          }),
        )
        .then(({ data }) =>
          data.user_lists.map(({ id, title }) => ({
            value: id,
            label: title,
          })),
        ),
  );

  return (
    <ReactSelect
      {...props}
      placeholder={__('Select a user list')}
      options={data}
      // @ts-expect-error: types
      isLoading={isLoading}
    />
  );
};

export default ReactSelectUserLists;
